'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSwitchProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  HOC that adds switched state to a component.
 *  Uses recompose to provide a component with the following props:
 *  - switched: Boolean of whether the component is switched or not
 *  - onClick: Function that will toggle switched and pass new value to
 *  onChange function if set. Composes with existing onClick handler if set.
 */

/**
 * Add switched state
 */
var withSwitchState = (0, _recompose.withState)('switched', 'asSwitch__setSwitched', function (_ref) {
  var defaultValue = _ref.defaultValue;
  return defaultValue || false;
});

/**
 * Add onSwitch handler. Updates hoc switched state and calls
 * onChange function with new value if not disabled.
 */
var withSwitchHandlers = (0, _recompose.withHandlers)({
  onSwitch: function onSwitch(_ref2) {
    var asSwitch__setSwitched = _ref2.asSwitch__setSwitched,
        disabled = _ref2.disabled,
        onChange = _ref2.onChange,
        onClick = _ref2.onClick,
        switched = _ref2.switched,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['asSwitch__setSwitched', 'disabled', 'onChange', 'onClick', 'switched']);
    return function () {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      // Only if not disabled
      //
      if (!disabled) {
        var value = 'value' in rest ? !rest.value : !switched;

        // If onChange, call onChange with opposite value of switched
        if (onChange) {
          onChange(value);
        }
        // Update HOC state
        asSwitch__setSwitched(value);

        // Call onClick if set
        if (onClick) {
          onClick(params);
        }
      }
    };
  }
});

/**
 * remove hoc state handler, map value of hoc state to switched prop.
 */
var mapSwitchProps = (0, _recompose.mapProps)(function (_ref3) {
  var asSwitch__setSwitched = _ref3.asSwitch__setSwitched,
      switched = _ref3.switched,
      rest = (0, _objectWithoutProperties3.default)(_ref3, ['asSwitch__setSwitched', 'switched']);
  return (0, _extends3.default)({}, rest, {
    // Use value if set as prop, otherwise hoc state
    switched: 'value' in rest ? rest.value : switched
  });
});

exports.mapSwitchProps = mapSwitchProps;
var asSwitch = (0, _recompose.compose)(withSwitchState, withSwitchHandlers, mapSwitchProps);

exports.default = asSwitch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/helpers/asSwitch.js
// module id = 434
// module chunks = 0